<template>
  <div class="content-wrapper-scroll">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h5>Logs</h5>
            </div>
            <div class="card-body">
              <div class="row gutters">
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <search
                      :class="{ 'is-invalid': errors.user_id }"
                      :customClass="{ 'is-invalid': errors.user_id }"
                      :initialize="meta.user_id"
                      id="user_id"
                      label="name"
                      placeholder="Select User"
                      :data="users"
                      @input="(users) => (meta.user_id = users)"
                    >
                    </search>
                    <span v-if="errors.user_id" class="invalid-feedback">{{
                      errors.user_id[0]
                    }}</span>
                    <div class="field-placeholder">User</div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">From Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.from_date"
                    />
                    <span v-if="errors.from_date" class="invalid-feedback">{{
                      errors.from_date[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <div class="field-placeholder">To Date</div>
                    <input
                      class="form-control form-control-sm"
                      type="date"
                      v-model="meta.to_date"
                    />
                    <span v-if="errors.to_date" class="invalid-feedback">{{
                      errors.to_date[0]
                    }}</span>
                  </div>
                </div>
                <!-- <div class="col-sm-3">
                  <div class="field-wrapper">
                    <search
                      :class="{ 'is-invalid': errors.template_id }"
                      :customClass="{ 'is-invalid': errors.template_id }"
                      :initialize="meta.template_id"
                      id="template_id"
                      label="template_name"
                      placeholder="Select Template"
                      :data="templates"
                      @input="(templates) => (meta.template_id = templates)"
                      @selectsearch="getTemplates(meta.template_id)"
                    >
                    </search>
                    <span v-if="errors.template_id" class="invalid-feedback">{{
                      errors.template_id[0]
                    }}</span>
                    <div class="field-placeholder">Template</div>
                  </div>
                </div> -->

                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <select
                      class="form-control"
                      :class="{ 'is-invalid': errors.log_type }"
                      placeholder="Log Type"
                      v-model="meta.log_type"
                      ref="log_type"
                    >
                      <option value="">Select Log Type</option>
                      <!-- <option>Select</option> -->
                      <option value="upload">Upload</option>
                      <!-- <option value="download">Download</option> -->
                    </select>
                    <span v-if="errors.log_type" class="invalid-feedback">{{
                      errors.log_type[0]
                    }}</span>
                    <div class="field-placeholder">
                      Log Type <span class="text-danger">*</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="field-wrapper">
                    <select
                      class="form-control"
                      :class="{ 'is-invalid': errors.status }"
                      placeholder="status"
                      v-model="statusValue"
                      ref="log_type"
                    >
                      <option value="">Select Status</option>
                      <!-- <option>Select</option> -->
                      <option value="true">Success</option>
                      <option value="false">Failed</option>
                    </select>
                    <span v-if="errors.status" class="invalid-feedback">{{
                      errors.status[0]
                    }}</span>
                    <div class="field-placeholder">
                      Status 
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="input-group field-wrapper">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Type here and press enter to search"
                      v-model="meta.search"
                      @keyup.enter="search"
                    />
                    <span class="input-group-text">
                      <i class="fas fa-search"></i>
                    </span>
                    &nbsp;
                  </div>
                </div>

                <div class="col-sm-3">
                  <button
                    type="submit"
                    v-if="status"
                    @click="search"
                    class="btn btn-primary btn-block btnn"
                  >
                    Search
                  </button>

                  <button
                    type="submit"
                    v-if="status"
                    @click="reset"
                    class="btn btn-danger btn-block btnn"
                  >
                    Reset
                  </button>

                  <!-- <a
                    v-can="'templates.export'"
                    :href="
                      $store.getters.pdfUrl +
                      'downloadTemplate?plant_id=' +
                      $store.getters.user.plant_id +
                      '&page=' +
                      meta.currentPage +
                      '&per_page=' +
                      meta.per_page +
                      '&field=' +
                      meta.field +
                      '&order_by=' +
                      meta.order_by +
                      '&department_id=' +
                      meta.department_id +
                      '&functional_id=' +
                      meta.functional_id +
                      '&category_id=' +
                      meta.category_id +
                      '&frequency_id=' +
                      meta.frequency_id +
                      '&search=' +
                      meta.search
                    "
                    target="_blank"
                    type="button"
                    class="btn btnn btn-success"
                  >
                    Export Templates
                  </a> -->

                  <!-- <router-link
                    to="/templates/upload"
                    v-can="'templates.import'"
                    class="btn btnn btn-secondary"
                    >Import Templates</router-link
                  > -->
                </div>
              </div>

              <div v-if="errors.length != 0" class="table-responsive tabletop">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="errors.length == 0">
                      <td colspan="11" class="text-center">No records found</td>
                    </tr>
                    <tr v-for="(error, key) in errors" :key="key">
                      <td>{{ meta.from + key }}</td>
                      <td>{{ error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive tabletop">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th @click="sort('name')">
                        User
                        <span>
                          <i
                            v-if="
                              meta.field == 'name' && meta.order_by == 'asc'
                            "
                            class="fas fa-sort-up"
                          ></i>
                          <i
                            v-else-if="
                              meta.field == 'name' && meta.order_by == 'desc'
                            "
                            class="fas fa-sort-down"
                          ></i>
                          <i v-else class="fas fa-sort"></i>
                        </span>
                      </th>
                      <th @click="sort('template_name')">
                        Template Name
                        <span>
                          <i
                            v-if="
                              meta.field == 'template_name' &&
                              meta.order_by == 'asc'
                            "
                            class="fas fa-sort-up"
                          ></i>
                          <i
                            v-else-if="
                              meta.field == 'template_name' &&
                              meta.order_by == 'desc'
                            "
                            class="fas fa-sort-down"
                          ></i>
                          <i v-else class="fas fa-sort"></i>
                        </span>
                      </th>
                      <th @click="sort('date_time')">
                        Date Time
                        <span>
                          <i
                            v-if="
                              meta.field == 'date_time' &&
                              meta.order_by == 'asc'
                            "
                            class="fas fa-sort-up"
                          ></i>
                          <i
                            v-else-if="
                              meta.field == 'date_time' &&
                              meta.order_by == 'desc'
                            "
                            class="fas fa-sort-down"
                          ></i>
                          <i v-else class="fas fa-sort"></i>
                        </span>
                      </th>
                      <th @click="sort('log_type')">
                        Log Type
                        <span>
                          <i
                            v-if="
                              meta.field == 'log_type' && meta.order_by == 'asc'
                            "
                            class="fas fa-sort-up"
                          ></i>
                          <i
                            v-else-if="
                              meta.field == 'log_type' &&
                              meta.order_by == 'desc'
                            "
                            class="fas fa-sort-down"
                          ></i>
                          <i v-else class="fas fa-sort"></i>
                        </span>
                      </th>
                      <th @click="sort('status')">
                        Status
                        <span>
                          <i
                            v-if="
                              meta.field == 'status' && meta.order_by == 'asc'
                            "
                            class="fas fa-sort-up"
                          ></i>
                          <i
                            v-else-if="
                              meta.field == 'status' && meta.order_by == 'desc'
                            "
                            class="fas fa-sort-down"
                          ></i>
                          <i v-else class="fas fa-sort"></i>
                        </span>
                      </th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="user_logs.length == 0">
                      <td colspan="10" class="text-center">No records found</td>
                    </tr>
                    <tr v-for="(user_log, key) in user_logs" :key="key">
                      <td>{{ meta.from + key }}</td>
                      <td>{{ user_log.user?.name }}</td>
                      <td>{{ user_log.template?.template_name }}</td>
                      <td>{{ user_log.date_time }}</td>
                      <td>{{ user_log.log_type }}</td>
                      <!-- <td class="text-center">
                        <input type="checkbox" v-model="user_log.status" />
                      </td> -->

                      <td class="text-center" :class="user_log.status ? 'text-success' : 'text-danger'">
                        {{ user_log.status ? 'Success' : 'Failed' }}
                      </td>
                      <td @click="openModal(user_log)" data-toggle="modal" data-target="#exampleModal" 
                        class="cursor-pointer text-primary text-center" style="font-size: 1rem;">
                        <i class="fas fa-eye"></i>
                    </td>

                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="form-actions-footer">
                <div class="text-end row">
                  <div class="col-sm-2">
                    <select
                      class="form-control"
                      v-model="meta.per_page"
                      @change="onPerPageChange"
                    >
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                    </select>
                  </div>
                  <div class="col-sm-10">
                    <Pagination
                      class="pagination pagination-sm"
                      :maxPage="meta.maxPage"
                      :totalPages="meta.lastPage"
                      :currentPage="meta.currentPage"
                      @pagechanged="onPageChange"
                    />
                  </div>

                  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                      <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Responses</h5>
                            <button type="button" class="close" @click="closeModal" data-dismiss="modal" aria-label="Close" style="background-color: red; color: white; padding: 2px 6px; border: none; border-radius: 6px;">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="card-header">
                                            <h6>Request Body</h6>
                                        </div>
                                        <div class="card-body hgt">
                                            <pre>{{ request_body_items }}</pre>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="card-header">
                                            <h6>Response Body</h6>
                                        </div>
                                        <div class="card-body hgt">
                                            <pre>{{ response_body_items }}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="close" @click="closeModal" aria-label="Close" style="background-color: red; color: white; padding: 8px 12px; border: none; border-radius: 6px;"> 
                            Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btnn {
  margin-top: 0.5rem;
}
</style>

<script>
let Search = require("@/components/Search.vue").default;
import Pagination from "@/components/Pagination.vue";
import { Modal } from 'bootstrap';

export default {
  components: { Pagination, Search },
  data() {
    return {
      check: "",
      status: true,
      errors: [],
      user_logs: [],
      templates: [],
      users: [],
      meta: {
        user_log_id: "",
        user_id: "",
        from_date: "",
        to_date: "",
        template_id: "",
        log_type: "upload",
        search: "",
        order_by: "desc",
        field: "user_log_id",
        per_page: 10,
        totalRows: 0,
        currentPage: 1,
        lastPage: 1,
        from: 1,
        maxPage: 1,
        plant_id: this.$store.getters.user.plant_id,
        status: '',
      },
      selectedLog: null,
      request_body_items: [],
      response_body_items: [],
      modalInstance: null,
    };
  },
  mounted() {
    this.getUsers();
    this.$store.commit("setModule", "UserLog");
    this.index();
  },

  computed: {
    formattedRequestBody() {
        return JSON.stringify(this.request_body_items, null, 2); // Pretty Print JSON
    },
    formattedResponseBody() {
        return JSON.stringify(this.response_body_items, null, 2);
    },
    statusValue: {
        get() {
          return this.meta.status === true ? "true" : this.meta.status === false ? "false" : "";
        },
        set(value) {
          this.meta.status = value === "true" ? true : value === "false" ? false : "";
        }
      }
    },
  
  methods: {
    view(user_log) {
        this.request_body_items = user_log.request;
        this.response_body_items = user_log.response;
    },
    openModal(user_log) {
      this.selectedLog = user_log;
      this.request_body_items = user_log.request;
      this.response_body_items = user_log.response;
      this.$nextTick(() => {
        const modalElement = document.getElementById('exampleModal');
        if (!this.modalInstance) {
          this.modalInstance = new Modal(modalElement);
        }
        this.modalInstance.show();
      });
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    index() {
      let vm = this;
      let uri =
        "paginateUserLogs?page=" +
        vm.meta.currentPage +
        "&search=" +
        vm.meta.search +
        "&order_by=" +
        vm.meta.order_by +
        "&field=" +
        vm.meta.field +
        "&per_page=" +
        vm.meta.per_page +
        "&user_id=" +
        vm.meta.user_id +
        "&from_date=" +
        vm.meta.from_date +
        "&to_date=" +
        vm.meta.to_date +
        "&log_type=" +
        vm.meta.log_type +
        "&template_id=" +
        vm.meta.template_id +
        "&status=" +
        vm.meta.status;
      vm.$store
        .dispatch("post", { uri: uri })
        .then(function (response) {
          console.log(response.data.data);
          vm.user_logs = response.data.data;

          vm.meta.totalRows = response.data.meta.total;
          vm.meta.lastPage = response.data.meta.last_page;
          vm.meta.from = response.data.meta.from;
          vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    reset() {
      let vm = this;
      vm.meta.user_id = "";
      vm.meta.template_id = "";
      vm.meta.from_date = "";
      vm.meta.to_date = "";
      vm.meta.search = "";
      // vm.meta.log_type = "";
      vm.meta.status = "";
      vm.$store.commit("setModule", "Template");
      vm.$store.commit("setPage", 1);
      vm.$store.commit("setMeta", null);
      vm.index();
    },

    getUsers() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getUsers" })
        .then(function (response) {
          vm.users = response.data.data;
          // vm.getTemplates();
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    getTemplates() {
      let vm = this;
      vm.$store
        .dispatch("post", { uri: "getTemplates" })
        .then(function (response) {
          vm.templates = response.data.data;
        })
        .catch(function (error) {
          vm.errors = error.response.data.errors;
          vm.$store.dispatch("error", error.response.data.message);
        });
    },

    deleteRow(template) {
      let vm = this;
      if (confirm("Do you want to delete this entry ?")) {
        let loader = vm.$loading.show();
        vm.$store
          .dispatch("delete", { uri: "deleteTemplate/" + template.template_id })
          .then(function () {
            loader.hide();
            vm.$store.dispatch("success", "Template is successfully deleted");
            vm.index();
          })
          .catch(function (error) {
            loader.hide();
            vm.errors = error.response.data.errors;
            vm.$store.dispatch("error", error.response.data.message);
          });
      }
    },

    toggle(user_log) {
      let vm = this;
      vm.meta.user_log_id = user_log.user_log_id;
      vm.$store.dispatch("post", {
        uri: "toggleUserLog",
        data: vm.meta,
      });
    },

    onPageChange(page) {
      this.meta.currentPage = page;
      this.index();
    },

    onPerPageChange() {
      this.meta.currentPage = 1;
      this.index();
    },
    sort(field) {
      this.meta.field = field;
      this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
      this.index();
    },
    search() {
      let vm = this;
      vm.meta.currentPage = 1;
      vm.$store.commit("setMeta", vm.meta);
      vm.$store.commit("setPage", vm.meta.currentPage);
      vm.index();
    },
  },
};
</script>

<style scoped>
.hgt {
    max-height: 300px;
    overflow-y: auto; 
    overflow-x: hidden;
    line-height: 22px;
}

.hgt pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 22px;
}
</style>